import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'alumni-reports-view-part',
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './alumni-reports.part.html',
})
export class AlumniReportsViewPart {
}